<template>
  <div class="app">
    <Header></Header>
    <div class="area1">
      <div class="title color333">任务描述</div>
      <p class="tip">请简单明了的向孩子说明任务，不超过20个字</p>
      <van-field maxlength="20" v-model="form.taskName" rows="4" autosize type="textarea" placeholder="请输入" />
    </div>
    <div class="area2">
      <div class="type">
        <div class="title color333">
          任务类型
          <span>(请选择任务类型)</span>
        </div>
        <div class="typeList">
          <div
            class="typeList-item"
            :class="item.active?'active':''"
            v-for="(item,index) in typeList"
            :key="index"
            @click="selType(index)"
          >{{item.label}}</div>
        </div>
        <div class="title color333">任务时间</div>
        <div class="dateList">
          <div
            v-for="(item,index) in dateList"
            class="dateList-item"
            :class="item.active?'active':''"
            :key="index"
            @click="selDate(index)"
          >{{item.label}}</div>
        </div>
      </div>
      <div class="score">
        <div class="title color333">可获得积分数量</div>
        <div class="scoreList">
          <div
            v-for="(item,index) in scoreList"
            class="scoreList-item"
            :class="item.active?'active':''"
            :key="index"
            @click="selScore(index)"
          >
            <img src="../assets/images/point.png" alt />
            <span>X{{item.label}}</span> 
          </div>
        </div>
      </div>
    </div>
    
    <div class="btn-area">
      <van-button type="primary" class="bg-green colorfff btn-confirm" @click="submit">保存</van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Toast} from "vant";
import {listByCode} from '../api/api-common';
import {addParentTask,getTParentTask,updateParentTask} from '../api/api-parentTask';
import Header from "../components/Header";
export default {
  components: {
    Header
  },
  
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      childInfo: state => state.childInfo,
      activeChildInfo: state => state.activeChildInfo
    })
  },
  data() {
    return {
      isAdd:true,
      form:{
          taskName:""
      },
      typeList: [],
      dateList: [],
      scoreList: []
    };
  },
  computed: {},
  watch: {},
  methods: {

      selType(index){
        if(!this.typeList[index].active){
              this.typeList.forEach(item=>{
                  item.active=false
              })
          }
          this.typeList[index].active=!this.typeList[index].active
      },
      selScore(index){
          if(!this.scoreList[index].active){
              this.scoreList.forEach(item=>{
                  item.active=false
              })
            this.scoreList[index].active=!this.scoreList[index].active;
          }
      },
      selDate(index){
        // 由于日期类型只能选择一个，所以不提供选择功能
        if(!this.dateList[index].active){
            this.dateList.forEach(item=>{
                item.active=false
            })
        }
        this.dateList[index].active=!this.dateList[index].active
      },
      submit(){
        if(!this.form.taskName){
          Toast.fail('请输入任务描述');
          return
        }
        
        let typeFlag=false;
        this.typeList.forEach(item=>{
          if(item.active){
            this.form.taskType=item.value;
            typeFlag=true
          }
        })
        if(!typeFlag){
          Toast.fail('请选择任务类型')
          return
        }

        let dateFlag=false;
        this.dateList.forEach(item=>{
          if(item.active){
            this.form.dayType=item.value;
            dateFlag=true
          }
        })
        if(!dateFlag){
          Toast.fail('请选择任务时间')
          return
        }
        
        let scoreFlag=false;
        this.scoreList.forEach(item=>{
          if(item.active){
            this.form.taskIntegral=parseInt(item.value);
            scoreFlag=true
          }
        })
        if(!scoreFlag){
          Toast.fail('请选择可获得积分数量')
          return
        }
        if(this.isAdd){
          addParentTask(this.form).then(res=>{
            if(res.code==200){
              Toast.success('保存成功');
              setTimeout(()=>{
                this.$router.go(-1)
              },1000)
            }else{
              Toast.fail(res.msg)
            }
          })
        }else{
          updateParentTask(this.form).then(res=>{
            if(res.code==200){
              Toast.success('保存成功');
              setTimeout(()=>{
                this.$router.go(-1)
              },1000)
            }else{
              Toast.fail(res.msg)
            }
          })
        }
      }
  },
  created() {
    //获取数据字典 TASK_TYPE==类型 DAY_TYPE==日期 TASK_INTEGRAL=积分
      Promise.all([listByCode("TASK_TYPE"),listByCode("DAY_TYPE"),listByCode("PARENT_TASK_INTEGRAL")]).then(res=>{
        res.forEach(item=>{
          item.data.forEach(itema=>{
            itema.active=false;
          })
        })
        this.typeList=res[0].data
        this.dateList=res[1].data
        this.scoreList=res[2].data
      }).then(()=>{
        
    //传入taskId代表修改
    //否则传入childId和dayType代表新增
        if(this.$route.query.taskId){
          this.form.id=this.$route.query.taskId;
          this.isAdd=false;
          getTParentTask(this.form.id).then(res=>{
            if(res.code==200){
              this.form=res.data;
              this.dateList.forEach(item=>{
                if(item.value==this.form.dayType){
                  item.active=true;
                }else{
                  item.active=false;
                }
              })
              this.$set(this,'dateList',this.dateList)
              this.scoreList.forEach(item=>{
                if(item.value==this.form.taskIntegral){
                  item.active=true;
                }else{
                  item.active=false;
                }
              })
              this.$set(this,'scoreList',this.scoreList)

              this.typeList.forEach(item=>{
                if(item.value==this.form.taskType){
                  item.active=true;
                }else{
                  item.active=false;
                }
              })
              this.$set(this,'typeList',this.typeList)
            }else{
              Toast.fail(res.msg)
            }
          })
        }else{
          this.isAdd=true;
          this.form.childId=this.$route.query.childId;
          this.dateList.forEach(item=>{
            if(item.value==this.$route.query.dayType){
              item.active=true;
            }else{
              item.active=false;
            }
          })
        }
      })
    
  },
  mounted() {
    
    
  }
};
</script>
<style scoped lang="less">
.app {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #ecf0f5;
}
.area1 {
  background: #fff;
  margin-top: 5px;
  overflow: hidden;
  padding: 0 15px;
}
.area2 {
  background: #fff;
  margin-top: 5px;
  overflow: hidden;
  padding-bottom: 10px
}
.title {
  margin: 12px 0;
}
.tip {
  font-size: 14px;
  color: rgba(189, 199, 210, 1);
}
.area1 /deep/ .van-cell {
  padding: 10px 10px;
  background: #edf0f4;
  margin: 10px 0;
}
.typeList {
  .typeList-item {
    display: inline-block;
    width: 40px;
    height: 28px;
    background: rgba(237, 240, 244, 1);
    border-radius: 2px;
    text-align: center;
    line-height: 28px;
    margin-right: 13px;
    color: #939ba4;
  }
  .active {
    background: rgba(135, 226, 205, 1);
    border-radius: 2px;
    color: #fff;
  }
}
.dateList{
    .dateList-item {
        display: inline-block;
        height: 28px;
        background: rgba(237, 240, 244, 1);
        border-radius: 2px;
        text-align: center;
        line-height: 28px;
        margin-right: 13px;
        color: #939ba4;
        padding: 4px 24px
    }
  .active {
    background: rgba(135, 226, 205, 1);
    border-radius: 2px;
    color: #fff;
  }
}
.type{
  padding: 0 15px;
}
.score{
    border-top: 1px solid #E2E4E8;
    margin-top: 15px;
    .title{
        padding-left:15px
    }
    .scoreList{
        margin-left: 15px
    }
    .scoreList-item{
        display: inline-block;
        background: rgba(237, 240, 244, 1);
        border-radius:8px;
        text-align: center;
        line-height: 28px;
        margin-right: 13px;
        margin-bottom: 10px;
        color: #939ba4;
        padding: 4px 17px;;
        color: #333;
        img{
            vertical-align: middle;
        }
        span{
            vertical-align: middle;
        }
    }
    .active{
        background: rgba(135, 226, 205, 1);
        border-radius: 8px;
        color: #fff;
    }
}
.btn-confirm{
  margin-top: 80px;
  width: 335px;
  left:20px;
  color: #fff;
  font-size: 16px;
  border-radius:22px;
}
.btn-confirm::after{
  border: none
}
</style>